// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__xrhWm","header":"styles_header__+l7IW"};